export default __webpack_public_path__ + "static/media/quest.35ef62df.svg";